export const ERROR_COUNT_ACTIONS = {
  add: 'add',
  remove: 'remove',
};

export const defaultExecutionHistoryErrorState = { show: false, error: null };
